import { Controller } from "@hotwired/stimulus"

// Periodically updates task aging CSS classes client-side
// so aging transitions happen live without server round-trips.
export default class TaskAgingController extends Controller {
  static targets = ["task"]
  static values = {
    threshold1: Number, // minutes
    threshold2: Number, // minutes
    threshold3: Number  // minutes
  }

  connect() {
    this.refresh()
    // Re-evaluate aging every 60 seconds
    this.timer = setInterval(() => this.refresh(), 60000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  refresh() {
    const now = Date.now()

    this.taskTargets.forEach(el => {
      if (el.dataset.completed === "true") return

      const queuedAt = new Date(el.dataset.queuedAt).getTime()
      const elapsedMinutes = (now - queuedAt) / 60000

      // Determine aging level
      let level = 0
      if (elapsedMinutes >= this.threshold3Value) level = 3
      else if (elapsedMinutes >= this.threshold2Value) level = 2
      else if (elapsedMinutes >= this.threshold1Value) level = 1

      // Get current level from classes
      const currentLevel = this.getCurrentLevel(el)

      if (level !== currentLevel) {
        // Remove old aging classes
        el.classList.remove("warm-1", "warm-2", "warm-3")

        // Add new one
        if (level > 0) {
          el.classList.add(`warm-${level}`)
        }

        // Show/hide requeue nudge
        const nudge = el.querySelector(".requeue-nudge")
        if (level >= 3 && !nudge) {
          // If nudge doesn't exist yet, we could reload via turbo
          // but for simplicity we'll let the next server render add it
        }
      }
    })
  }

  getCurrentLevel(el) {
    if (el.classList.contains("warm-3")) return 3
    if (el.classList.contains("warm-2")) return 2
    if (el.classList.contains("warm-1")) return 1
    return 0
  }
}
